import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../core/services/user/user.service';
import { HttpClient } from '@angular/common/http';
import { CollisService } from 'src/app/core/services/collis/collis.service';
import { UserOptions } from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { ColissessionService } from '../../../core/services/colissession/colissession.service';
import { DatePipe } from '@angular/common';
import { data } from 'jquery';
import { RecetteService } from '../../../core/services/recette/recette.service';
import { BagageService } from '../../../core/services/bagage/bagage.service';
import { VoyageService } from '../../../core/services/voyage/voyage.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ProfileComponent } from 'src/app/module/account/profile/profile.component';
import { LogService } from '../../../core/services/log/log.service';
import { ImageCacheService } from 'src/app/core/services/image/image-cache.service';
import { ReportPrintService } from '../../../core/services/print/report-print.service';
import { SessionCloseService } from '../../../core/services/session/session-close.service';
import { SessionPrintService } from '../../../core/services/print/session-print.service';
import Swal from 'sweetalert2';
import { timer, Subscription } from 'rxjs';
import { API_URL } from 'src/app/core/configurations/server-config';

interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {

  sessionNumber: any;
  base64: any;
  collis: any;
  picture: any;
  sessiondetail: any;
  name: string;
  depense: any;
  pageheight: any;
  recette: any;
  bagage: any;
  ispopup: boolean;
  pageHeights3: any;
  pageHeights2: any;
  countlogs: any = 0;
  profileImageBase64: string | null = null;
  translateImageBase64: string | null = null;
  englishFlagBase64: string | null = null;
  frenchFlagBase64: string | null = null;
  
  isInternetOnline: boolean = true;
  offlineCount: number = 0;
  private pingSubscription: Subscription = Subscription.EMPTY;

  constructor( private dialog: MatDialog, private router: Router, private translationService: TranslationService, private translate: TranslateService, private sessionservice: ColissessionService, private collisservice: CollisService,
    private userservice: UserService, private http: HttpClient, private datepipe: DatePipe, private recetteservice: RecetteService,
    private bagageservice: BagageService,private logservice: LogService,
    private voyageservice:VoyageService,
    private imageCacheService: ImageCacheService,
    private reportPrintService: ReportPrintService,
    private sessionCloseService: SessionCloseService,
    private sessionPrintService: SessionPrintService){
      this.ispopup = false;
    let personid: any = localStorage.getItem('userinfo');
    personid = JSON.parse(personid);
    this.picture = personid[0].profile;
    this.name = personid[0].nom + ' ' + personid[0].prenom;
    if (localStorage.getItem('session') != null && localStorage.getItem('session') != ''){
      this.getsessioninfo(localStorage.getItem('session'));
    }
    this.countlog();
    this.loadProfileImage();
    this.loadHeaderImages();
    this.startConnectionCheck();
  }

  startConnectionCheck() {
    this.pingSubscription = timer(0, 15000).subscribe(() => {
      this.http.get(`${API_URL}/rest/ping`, { responseType: 'text' })
        .subscribe({
          next: (res) => {
            try {
              const parsed = JSON.parse(res);
              this.isInternetOnline = parsed.online;
              this.offlineCount = parsed.offlineCount;
            } catch (e) {
              this.isInternetOnline = (res === 'true');
              this.offlineCount = this.isInternetOnline ? 0 : 1;
            }
          },
          error: () => {
            this.isInternetOnline = false;
            this.offlineCount = 0; // Default when backend itself is offline/down
          }
        });
    });
  }

  ngOnDestroy() {
    this.pingSubscription.unsubscribe();
  }

  loadProfileImage(): void {
    this.imageCacheService
      .getImage('assets/images/profile.jpg')
      .subscribe({
        next: (base64: string) => {
          this.profileImageBase64 = base64;
        },
        error: (error: any) => {
          console.error('Error loading profile image:', error);
          // Fallback to direct path will be used via template binding
        }
      });
  }

  loadHeaderImages(): void {
    // Load translate icon
    this.imageCacheService.getImage('assets/images/translate.png').subscribe({
      next: (base64: string) => {
        this.translateImageBase64 = base64;
      },
      error: (error: any) => {
        console.error('Error loading translate image:', error);
      }
    });

    // Load English flag
    this.imageCacheService.getImage('assets/images/english.jpg').subscribe({
      next: (base64: string) => {
        this.englishFlagBase64 = base64;
      },
      error: (error: any) => {
        console.error('Error loading English flag:', error);
      }
    });

    // Load French flag
    this.imageCacheService.getImage('assets/images/french.jpg').subscribe({
      next: (base64: string) => {
        this.frenchFlagBase64 = base64;
      },
      error: (error: any) => {
        console.error('Error loading French flag:', error);
      }
    });
  }

  viewProfil(): any {

    this.ispopup = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {};
    const dialogref = this.dialog.open(ProfileComponent , {
      width: 'auto', height: 'auto', autoFocus: true, disableClose: dialogConfig.disableClose, data: {}
    });
  }

  countlog(): any{
    this.logservice.countlogs().subscribe((data: any)=>{
      this.countlogs = data
    })
  }

  refreshtab(): any{
    const currentUrl = this.router.url;
    // const currentUrl = 'collis/mail';
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
}

  logout(): any{
    localStorage.removeItem('userinfo');
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('userRole');
    localStorage.removeItem('agenceinso');
    localStorage.removeItem('agence');
    localStorage.removeItem('session');
    localStorage.removeItem('authority');
    localStorage.removeItem('lastprint');
    this.router.navigateByUrl('login');
    localStorage.removeItem('voyage');
    localStorage.clear();
  }

  closesession(): any {
    Swal.fire({
      title: 'Fermer la session',
      text: 'Voulez-vous vraiment fermer votre session ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, fermer',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.getlogo();
        let personid: any = localStorage.getItem('userinfo');
        personid = JSON.parse(personid);
        const sessionid = '';
        const session = localStorage.getItem('session');

    this.userservice.updateusersession(personid[0].idpersonnel, sessionid, session).subscribe(
      (response: any) => {
        // Success - Proceed with session closing
        this.getsessioninfoBeforeCloseSession(session);
      },
      (error: any) => {
        // Error - Stop process and notify user
        console.error('update session error', error);

        // Show error to user
        Swal.fire({
          title: 'Erreur',
          text: 'Une erreur s\'est produite lors de la fermeture de la session.',
          icon: 'error',
          confirmButtonText: 'OK'
        }).then(() => {
          this.getsessioninfoBeforeCloseSession(session);
        });
      }
    );
      }
    });
  }

  changeLanguage(lang: any): any {
    if (lang != undefined && lang !== localStorage.getItem('lang')) {
      this.translationService.changeLanguage(lang, true);
    }
  }

  changeLang(language: string): any{
    this.translate.use(language);
  }

  closetab(): void{
    window.close();
  }

  async print(session: any): Promise<any> {
    if (this.sessiondetail) {
      this.sessiondetail.sessionCount = this.sessiondetail.sessionCount || 1;
      this.sessiondetail.name = this.name;
    }
    await this.sessionPrintService.printColisSession(this.sessiondetail || session);
    setTimeout(() => {
      this.clearSessionAndLogout();
    }, 300);
  }

  async print2(session: any): Promise<any> {
    if (this.sessiondetail) {
      this.sessiondetail.sessionCount = this.sessiondetail.sessionCount || 1;
      this.sessiondetail.name = this.name;
    }
    await this.sessionPrintService.printMixedSessionSummary(this.sessiondetail || session);
    setTimeout(() => {
      this.clearSessionAndLogout();
    }, 300);
  }

  private clearSessionAndLogout() {
    localStorage.removeItem('userinfo');
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('userRole');
    localStorage.removeItem('agenceinso');
    localStorage.removeItem('agence');
    localStorage.removeItem('authority');
    localStorage.removeItem('lastprint');
    localStorage.removeItem('section');
    this.router.navigateByUrl('login');
    localStorage.removeItem('session');
    localStorage.removeItem('voyage');
  }

  async getlogo(): Promise<any> {
    // Use image cache service for non-blocking, cached image loading
    this.imageCacheService
      .getImage('../../../../assets/images/logogen.jpg')
      .subscribe({
        next: (base64: string) => {
          this.base64 = base64;
        },
        error: (error: any) => {
          console.error('Error loading logo:', error);
        }
      });
  }

  async getsessioninfo(session: any): Promise<any> {
    await this.sessionservice.getsessiondetail(session).subscribe((response: any) => {
      this.sessiondetail = response;
    });
  }

  async getsessioninfoBeforeCloseSession(session: any): Promise<any> {
    this.sessionCloseService.closeSession(session, this.name, this.base64);
  }


}
